import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import Header from '@/base/Header';
import Back from '@/base/Back';
import Vant, { Dialog, ImagePreview, Lazyload, Toast } from 'vant';
import 'vant/lib/index.css';
Vue.component('Header', Header);
Vue.component('Back', Back);
Vue.use(VueClipboard);
Vue.use(Vant);
Vue.use(Lazyload, {
  lazyComponent: true
});
Toast.setDefaultOptions({
  duration: 1500
});
Vue.prototype.$ImagePreview = ImagePreview;
Vue.prototype.$Dialog = Dialog;